import React, { Component } from 'react';

import Accordion from 'common/common/Accordion';
import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';
import { SupportedLanguages } from 'common/i18n/supportedLanguages';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListEntriesBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <p className="heading">List entries</p>
          <p className="text">Returns a list of changelog entries. Sorted by newest.</p>
          <p className="text">
            To request translated changelog items, use the Accept-Language header in your HTTP
            request to specify the preferred language for the response.
          </p>
          <Accordion
            className="accordion"
            defaultOpen={false}
            title="Supported Languages:"
            showDivider={true}>
            <ul className="list">
              {Object.entries(SupportedLanguages).map(([key, value]) => (
                <li className="listItem" key={key}>
                  {key}: {value}
                </li>
              ))}
            </ul>
          </Accordion>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'Fetch only entries with at least one of the labels in the array.',
                heading: 'labelIDs',
                subheading: 'array (optional)',
              },
              {
                description:
                  "The number of entries you'd like to fetch. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description:
                  "The number of entries you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
              {
                description:
                  'The order in which the entries should be fetched. Options include: "created", "lastSaved", "nonPublishedFirst", "publishedAt". Defaults to "nonPublishedFirst" if not specified.',
                heading: 'sort',
                subheading: 'string (optional)',
              },
              {
                description:
                  'The type of entries to fetch. Value can be "new", "improved", or "fixed".',
                heading: 'type',
                subheading: 'string (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with a "entries" property that contains an array of entry objects. There's
            also a "hasMore" property that specifies whether this query returns more entries than
            the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/entries/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/entries/list"
            body={`\\
    -d apiKey=YOUR_API_KEY`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "hasMore": false,
  "entries": [{
    "id": "553c3ef8b8cdcd1501ba123b",
    "created": "${this.createdAt.toISOString()}",
    "labels": [{
      "id": "553c3ef8b8cdcd1501ba8761",
      "created": "${this.createdAt.toISOString()}",
      "entryCount": 4,
      "name": "Feature",
      "url": "https://your-company.canny.io/admin/changelog?labels=feature"
    }],
    "lastSaved": "${this.createdAt.toISOString()}",
    "markdownDetails": "# heading\\n**bold**\\n[link](https://canny.io)",
    "plaintextDetails": "heading\\nbold\\nlink",
    "posts": [{
      "category": {
        "id": "553c3ef8b8cdcd1501ba2234",
        "name": "Dashboard",
        "postCount": 42,
        "url": "https://your-company.canny.io/admin/board/feature-requests?category=dashboard"
      },
      "commentCount": 2,
      "eta": "February ${new Date().getFullYear()}",
      "id": "553c3ef8b8cdcd1501ba4444",
      "imageURLs": [],
      "jira": {
        "linkedIssues": [{
          "id": "123",
          "key": "ID-123",
          "url": "https://your-company.atlassian.net/browse/ID-123"
        }]
      },
      "score": 13,
      "status": "planned",
      "tags": [{
        "id": "553c3ef8b8cdcd1501ba3234",
        "name": "iOS",
        "postCount": 15,
        "url": "https://your-company.canny.io/admin/board/feature-requests?tags=ios"
      }],
      "title": "post-title",
      "url": "https://your-company.canny.io/admin/board/feature-requests/p/post-title"
    }],
    "publishedAt": "${this.createdAt.toISOString()}",
    "reactions": {
      "like": 2
    },
    "scheduledFor": null,
    "status": "published",
    "title": "Entry title",
    "types": ["new", "improved"],
    "url": "https://your-company.canny.io/changelog/entry-title"
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
